import './ResponseAvatarsStrip.scss';

import React, {
  memo,
  useEffect,
  useRef,
} from 'react';

import CustomAvatar from '../../../../components/CustomAvatar/CustomAvatar';
import { DEFAULT_AVATAR } from '../../../../shared/data';
import {
  ITQServiceRequestResponse,
} from '../../../../types/tqConnectTypes/service-requests';

const AVATAR_SIZE = 44;
const SELECTED_BORDER_COLOR = '#f97316';

interface ResponseAvatarsStripProps {
  responses: ITQServiceRequestResponse[];
  selectedResponseId: string | null;
  onSelectResponse: (response: ITQServiceRequestResponse) => void;
}

const ResponseAvatarsStrip: React.FC<ResponseAvatarsStripProps> = ({
  responses,
  selectedResponseId,
  onSelectResponse,
}) => {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const selectedItemRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (!selectedResponseId) return;
    const scrollEl = scrollContainerRef.current;
    const selectedEl = selectedItemRef.current;
    if (!scrollEl || !selectedEl) return;

    const scrollLeft =
      selectedEl.offsetLeft -
      scrollEl.offsetWidth / 2 +
      selectedEl.offsetWidth / 2;
    scrollEl.scrollTo({
      left: Math.max(0, scrollLeft),
      behavior: 'smooth',
    });
  }, [selectedResponseId]);

  if (!responses?.length) {
    return null;
  }

  return (
    <div className="response-avatars-strip">
      <div ref={scrollContainerRef} className="response-avatars-strip__scroll">
        <div className="response-avatars-strip__spacer" aria-hidden="true" />
        {responses.map((item) => {
          const respondedBy = item.respondedBy;
          const isSelected = item._id === selectedResponseId;

          return (
            <button
              key={item._id}
              ref={isSelected ? selectedItemRef : undefined}
              type="button"
              className="response-avatars-strip__avatar-wrap"
              onClick={() => onSelectResponse(item)}
              aria-pressed={isSelected}
              aria-label={`View response by ${respondedBy?.name ?? 'Unknown'}`}>
              <CustomAvatar
                size={AVATAR_SIZE}
                src={respondedBy?.profilePicUrl || DEFAULT_AVATAR}
                name={respondedBy?.name}
                border={isSelected ? 3 : 1.5}
                selected={isSelected}
                borderColor={isSelected ? SELECTED_BORDER_COLOR : undefined}
                defaultColor="var(--border, #e5e7eb)"
                className="response-avatars-strip__avatar"
              />
            </button>
          );
        })}
        <div className="response-avatars-strip__spacer" aria-hidden="true" />
      </div>
    </div>
  );
};

export default memo(ResponseAvatarsStrip);
